import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map,filter, pluck } from "rxjs/operators";
import { AccesoService } from '../acceso/acceso.service';
import { environment } from '../../../environments/environment';
import { Observable } from "rxjs";
import { SessionStorageService } from '../storage/sessionStorage.service';
import { LocalService } from '../storage/localService';
import { FiltrosDocumentosNegociables } from "app/models/FiltrosDocumentosNegociables";


@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  readonly urlBase =  environment.rutaBase;
  TOKEN : string;
  header : HttpHeaders;
  idEmpresa_Factor : any;
  message: Observable<any>;
  datos:any = [];
  constructor(private http: HttpClient ,
     private accesoService :AccesoService,
    private sessionStorageService: SessionStorageService,
    private localService : LocalService) {
    this.header = this.accesoService.desencriptarTOKEN();
    this.datoStorage()
  }
  datoStorage(){
      this.message = this.sessionStorageService.storageChange$.pipe(
        filter(({ storageArea }) => storageArea === "sessionStorage"),
        filter(({ key }) => key === '1cefada07eb9',),
        pluck("value")
      );
     this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'))
     if (this.idEmpresa_Factor == undefined) {
      this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom')
     } 
    }


  obtenerDatosDashboard(periodo){

    let headers = this.header;
    return this.http.get(`${this.urlBase}/reporte/general?idEmpresa_Factor=${this.idEmpresa_Factor}&Periodo=${periodo}`,{headers}).pipe().map( data => {  
                    return data[0] 
                  } ); 
  }

  obtenerDatosFacturaDashboard(){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/reporte/ultimos/comprobantes?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers})
          .pipe().map( data => { return data} );
 
  }

  obtenerDatosContratosDashboard(){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/reporte/ultimos/contratos?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers})
          .pipe().map( data => { return data} );

  }

  obtenerDnDashboard(Filtros :FiltrosDocumentosNegociables , estado:any,numero:any){
    let headers = this.header;

    
    return this.http
      .get(
        `${this.urlBase}/comprobante?idEmpresa_Factor=${this.idEmpresa_Factor}&NumeroPagina=1&NumeroRegistro=${numero}&NumeroCp=${Filtros.Numero}&ExisteAdjunto=${Filtros.Adjunto}&Tipo_Emision=${Filtros.Tipo_Emision}&Tipo_Comprobante=${Filtros.Tipo_Comprobante}&idProveedor=${Filtros.Id}&Estado=${estado}`,{headers}
      )
      .pipe(
        map((data) => {
          this.datos = data;         
          return data;
        })
      );
  }

}
